import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class RetencionesCatalogoManager {
  static __values = {};

  static async boot() {
    let value = await Storage.get('catalogo.retenciones');

    const params = {
      name: 'r',
      version: !!value ? value.version : '0',
    };

    let response = {};

    try {
      response = await Http.get('/api/catalogos/grupos', { params });

      if (!!response.data && response.data.length > 0) {
        value = {
          version: response.data[0].version,
          data: response.data,
        };

        await Storage.put('catalogo.retenciones', value);
      }

      if (!!value) {
        for (const item of value.data) {
          RetencionesCatalogoManager.__values[item.name] = item.values;
        }
      }
    } catch (error) {
      throw new Error('Los catálogos de Retenciones no están disponibles');
    }
  }

  static get(catalog, _default = null) {
    return RetencionesCatalogoManager.__values[catalog] || _default;
  }

  static all() {
    return RetencionesCatalogoManager.__values;
  }
}

export default RetencionesCatalogoManager;
